import React from 'react';

function MapBackground({ className = '', ...props }) {
  return (
    <svg
      className={`map-background ${className}`}
      viewBox="0 0 1200 460"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path
        className="map-background__land"
        d="M74 225 129 181 209 162 267 128 349 136 415 112 500 127 569 103 650 121 726 105 796 125 878 118 943 145 1024 151 1128 203 1090 245 1012 253 954 285 870 278 797 308 716 294 651 323 574 308 508 335 432 309 364 323 297 294 226 302 166 269 101 264Z"
      />
      <g className="map-background__divisions">
        <path d="M208 163 234 222 226 302" />
        <path d="M349 136 361 220 364 323" />
        <path d="M500 127 494 213 508 335" />
        <path d="M650 121 640 214 651 323" />
        <path d="M796 125 781 216 797 308" />
        <path d="M943 145 923 217 954 285" />
        <path d="M129 181 234 222 361 220 494 213 640 214 781 216 923 217 1090 245" />
        <path d="M267 128 297 294" />
        <path d="M415 112 432 309" />
        <path d="M569 103 574 308" />
        <path d="M726 105 716 294" />
        <path d="M878 118 870 278" />
      </g>
    </svg>
  );
}

export default MapBackground;